<script setup></script>

<template>
    <svg
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 37.558 37.549"
        aria-hidden="true"
    >
        <path
            d="M18.708,40.972A9.627,9.627,0,1,0,28.335,50.6,9.612,9.612,0,0,0,18.708,40.972Zm0,15.886A6.259,6.259,0,1,1,24.967,50.6,6.27,6.27,0,0,1,18.708,56.859Zm12.267-16.28a2.246,2.246,0,1,1-2.246-2.246A2.24,2.24,0,0,1,30.975,40.579Zm6.376,2.279c-.142-3.008-.83-5.672-3.033-7.868s-4.86-2.882-7.868-3.033c-3.1-.176-12.392-.176-15.492,0-3,.142-5.664.83-7.868,3.025S.208,39.841.057,42.849c-.176,3.1-.176,12.392,0,15.492C.2,61.35.886,64.014,3.09,66.209s4.86,2.882,7.868,3.033c3.1.176,12.392.176,15.492,0,3.008-.142,5.672-.83,7.868-3.033s2.882-4.86,3.033-7.868C37.527,55.242,37.527,45.958,37.351,42.858Zm-4.005,18.81a6.337,6.337,0,0,1-3.569,3.569c-2.472.98-8.337.754-11.068.754s-8.6.218-11.068-.754A6.337,6.337,0,0,1,4.07,61.668C3.09,59.2,3.316,53.331,3.316,50.6s-.218-8.6.754-11.068A6.337,6.337,0,0,1,7.64,35.962c2.472-.98,8.337-.754,11.068-.754s8.6-.218,11.068.754a6.337,6.337,0,0,1,3.569,3.569c.98,2.472.754,8.337.754,11.068S34.326,59.2,33.346,61.668Z"
            transform="translate(0.075 -31.825)"
        />
    </svg>
</template>
